<script setup>
const route = useRoute()

const showNotice = ref(false)
const localStorageName = `show-notice-printemps-pour-la-planete`

const showBlock = computed(() => {
  if (route.query?.domaines?.split('|').includes('Protection de la nature')) {
    return false
  }
  return showNotice.value
})

onMounted(() => {
  const storedValue = localStorage.getItem(localStorageName)
  showNotice.value = storedValue !== 'false'
})

const closeNotice = () => {
  localStorage.setItem(localStorageName, 'false')
  showNotice.value = false
}

const { $plausible, $stores } = useNuxtApp()

const onClick = () => {
  $plausible.trackEvent('Clique - Opération nationale - Notice', {
    props: {
      isLogged: $stores.auth.isLogged,
      path: route.path,
      operation: 'Printemps pour la planète',
    },
  })
}
</script>

<template>
  <transition
    enter-active-class="transition ease-out duration-100"
    enter-from-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-75"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95"
  >
    <div v-if="showBlock" id="notice-printemps-pour-la-planete" class="mb-8 sm:mb-12">
      <div
        class="relative p-6 w-full max-w-[996px] mx-auto bg-[#F5F7FF] border border-[#BDCDFF] rounded shadow-lg z-10"
      >
        <button type="button" class="p-2 absolute top-2 right-2" @click="closeNotice">
          <RiCloseFill class="h-4 w-4 fill-jva-blue-500" aria-hidden="true" />
        </button>

        <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 sm:pr-12">
          <img
            src="/images/operations/logo-printemps-pour-la-planete.svg"
            alt="Printemps pour la planète"
            width="64"
            height="64"
            class="flex-none w-[64px] h-[64px] sm:w-[64px] sm:h-[64px]"
          />
          <div class="flex-1">
            <h4 class="text-base sm:text-lg font-bold">
              Rejoignez le mouvement Printemps pour la planète
            </h4>
            <p class="text-sm">
              Du 1er au 30 avril, passons de l’éveil à l’action pour faire du bien à notre planète.
            </p>
          </div>
          <div>
            <DsfrButton
              to="/missions-benevolat?domaines=Protection+de+la+nature"
              type="secondary"
              size="sm"
              class="!bg-transparent hover:!bg-white"
              @click="onClick"
            >
              Voir les missions
            </DsfrButton>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
